import React from 'react';
import { sumBy, meanBy, map } from 'lodash';
import DiffAndChange from '../DiffAndChange';
import { splitByThousands, convertToThousands } from '../../../helpers/NumberFormatter';

export {
	summaryFooter,
	diffFooter
}

function summaryFooter(totals, key, currency, digits) {
	return <React.Fragment>
		{convertToThousands(totals[`curr_${key}_income`], digits, currency)}
		<br/>
		{convertToThousands(totals[`curr_${key}_quantity`], digits, currency)}
	</React.Fragment>;
}

function diffFooter(totals, key) {
	return <React.Fragment>
		<DiffAndChange className="percent-value" field={`${key}_income`} item={totals}/>
		<br />
		<DiffAndChange className="percent-value" field={`${key}_quantity`} item={totals}/>
	</React.Fragment>
}
